var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustriekunde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 102.992,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 50,
    y: 140,
    width: 10,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 70,
    y: 140,
    width: 10,
    height: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 90,
    y: 140,
    width: 10,
    height: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 110,
    y: 140,
    width: 10,
    height: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 130,
    y: 140,
    width: 10,
    height: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 150,
    y: 140,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "M70,30c8.06,0,12.66,2.21,18.47,5.01,7.29,3.51,15.55,7.49,31.53,7.49v-10c-13.7,0-20.56-3.3-27.19-6.5-6.13-2.95-12.46-6-22.81-6-22.15,0-33.43,13.79-33.9,14.38l7.79,6.27c.36-.43,8.95-10.65,26.12-10.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "M174.02,77.6c-18.66,3.73-41.87,20.07-54.02,29.45v-30.65l-5.98,1.2c-18.66,3.73-41.87,20.07-54.02,29.45V47.5H20V180H180V76.4l-5.98,1.2ZM30,57.5h20v12.5H30v-12.5Zm140,112.5H30V80h20v40h9.81c6.27-5.16,30.41-24.36,50.19-30.97v30.97h9.81c6.27-5.16,30.41-24.36,50.19-30.97v80.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustriekunde);
export default __webpack_public_path__ + "static/media/industriekunde.c1408cbbd97565b6ee7cbecdb4feaf05.svg";
export { ForwardRef as ReactComponent };